import ApiService from './../api/ApiService';
import Urls from './../api/Urls';
import Config from '../constants/Config';
import Group from '../models/Group';
import { getContentLanguage } from '../utils/commonUtils';

export function getGroups(params) {
    return new ApiService({
        baseURL: Config.API_VOUCHER,
        endpoint: Urls.GROUP_LIST,
        params: params,
        parser: groupsDataParser,
    }).get();
}

export function getAllGroups(params) {
    return new ApiService({
        baseURL: Config.API_VOUCHER,
        endpoint: Urls.GROUP_LIST_ALL,
        params: params,
        parser: groupAllDataParser,
    }).get();
}

export function getGroupDetail(id) {
    return new ApiService({
        baseURL: Config.API_VOUCHER,
        endpoint: Urls.GROUP_DETAIL,
        endpointParams: { id },
        parser: data => new Group(data.data),
    }).get();
}

export function createGroup(group) {
    return new ApiService({
        baseURL: Config.API_VOUCHER,
        endpoint: Urls.GROUP_CREATE,
    }).post(group.export());
}

export function updateGroup(group) {
    return new ApiService({
        baseURL: Config.API_VOUCHER,
        endpoint: Urls.GROUP_UPDATE,
    }).put(group.export());
}

export function deleteGroup(id) {
    return new ApiService({
        baseURL: Config.API_VOUCHER,
        endpoint: Urls.GROUP_DELETE,
        endpointParams: { id },
    }).delete();
}

export function cloneGroup(id) {
    return new ApiService({
        baseURL: Config.API_VOUCHER,
        endpoint: Urls.GROUP_CLONE,
    }).post({ groupId: id });
}

export function importGroup(formData) {
    return new ApiService({
        baseURL: Config.API_VOUCHER,
        endpoint: Urls.GROUP_IMPORT,
    }).post(formData);
}

export function exportGroup(params) {
    return new ApiService({
        baseURL: Config.API_VOUCHER,
        endpoint: Urls.GROUP_EXPORT_EXCEL,
        params,
    }).get();
}

export function createGroupTranslate(group) {
    return new ApiService({
        baseURL: Config.API_VOUCHER,
        endpoint: Urls.GROUP_TRANSLATE_CREATE,
    }).post(group.export(true).translate());
}

export function updateGroupTranslate(group) {
    return new ApiService({
        baseURL: Config.API_VOUCHER,
        endpoint: Urls.GROUP_TRANSLATE_UPDATE,
    }).put(group.export(true).translate());
}

export function deleteGroupTranslate(id) {
    return new ApiService({
        baseURL: Config.API_VOUCHER,
        endpoint: Urls.GROUP_TRANSLATE_DELETE,
        endpointParams: { id },
    }).delete();
}

export function exportProductFeed(params = {}) {
    return new ApiService({
        baseURL: Config.API_VOUCHER,
        endpoint: Urls.GROUP_EXPORT_PRODUCT_FEED,
        params,
        isDownload: true,
        headers: {
            'accept-language': getContentLanguage() === 'all' ? 'vi-VN' : getContentLanguage()
        }
    }).get();
}

export function reindexProduct(params = {}) {
    return new ApiService({
        baseURL: Config.API_VOUCHER,
        endpoint: Urls.GROUP_REINDEX_PRODUCT,
        params,
    }).post();
}

function groupsDataParser(data = {}) {
    return {
        ...data.data,
        result: (data.data.result || []).map(item => new Group(item))
    }
}

function groupAllDataParser(data = {}) {
    return (data.data || []).map(item => new Group(item))
}